<!--
 * @Author: wufei
 * @Date: 2020-08-13 13:43:37
 * @LastEditTime: 2020-08-21 11:20:21
 * @Description:
 * @FilePath: \mobile-revive\src\views\report\reviveReport\basic.vue
-->
<template>
  <div class="basic-report">
    <div class="header">
      <div class="project-name">
        <span class="name">{{ replayForm.landName | unitFormat }}</span>
        <div v-if="replayForm.isObtains" class="my-button success">我司获取</div>
        <div v-if="replayForm.isFocus" class="my-button success">重点跟进</div>
      </div>
      <div class="project-name te">
        <span class="name">{{ replayForm.projectName | unitFormat }}</span>
        <span v-for="(item,index) in devEnterprise" :key="index" class="my-button info">{{ item }}</span>
      </div>
    </div>

    <div class="content">
      <div class="precise">
        <span class="name">预测精准度</span>
        <div v-if="replayForm.evalType" class="my-button white">{{ replayForm.evalType | formatterAac }}</div>
      </div>

      <report-menu :cur="active" :is-obtains="isObtains" @switchMenu="switchMenu" />

      <div class="list">
        <div class="unit">
          <div class="label">事业部</div>
          <div class="value">{{ replayForm.deptName || '--' }}</div>
        </div>
        <div class="unit">
          <div class="label">城市</div>
          <div class="value">{{ replayForm.cityName || '--' }}</div>
        </div>
        <div class="unit">
          <div class="label">板块</div>
          <div class="value">{{ replayForm.plateName || '--' }}</div>
        </div>
        <div class="unit">
          <div class="label">获取方式</div>
          <div class="value">{{ replayForm.obtainManner | filterObtain(obtainOptions) }}</div>
        </div>
        <div class="unit">
          <div class="label">投资版利润率</div>
          <div class="value">{{ replayForm.cifiNetProfitRatio | unitFormat('%') }}</div>
        </div>
        <div class="unit">
          <div class="label">预计整盘创造利润率</div>
          <div class="value">{{ replayForm.firstProfitsMargin | unitFormat('%') }}</div>
        </div>
        <div class="unit">
          <div class="label">拿地时间</div>
          <div class="value">{{ replayForm.participationTime | newParseTime('{y}-{m}-{d}') }}</div>
        </div>
        <div class="unit">
          <div class="label">占地面积</div>
          <div class="value">{{ replayForm.floorArea | unitFormat('㎡') }}</div>
        </div>
        <div class="unit">
          <div class="label">计容面积</div>
          <div class="value">{{ replayForm.areaMeterCapacity | unitFormat('㎡') }}</div>
        </div>
        <div class="unit">
          <div class="label">容积率</div>
          <div class="value">{{ replayForm.plotRatio | unitFormat }}</div>
        </div>
        <div class="unit">
          <div class="label">限高</div>
          <div class="value">{{ replayForm.limitHigh | unitFormat('m') }}</div>
        </div>
        <div class="unit">
          <div class="label">成交价格</div>
          <div class="value">{{ replayForm.totalPrice | unitFormat('万元') }}</div>
        </div>
        <div class="unit">
          <div class="label">溢价率</div>
          <div class="value">{{ replayForm.overPriceRate | unitFormat('%') }}</div>
        </div>
        <div class="unit">
          <div class="label">名义楼板价</div>
          <div class="value">{{ replayForm.nominalFloorPrice | unitFormat('元/㎡') }}</div>
        </div>
        <div class="unit">
          <div class="label">实际楼板价</div>
          <div class="value">{{ replayForm.realFloorPrice | unitFormat('元/㎡') }}</div>
        </div>

        <div class="row-unit">
          <div class="label">特殊限制要求</div>
          <div class="value"><ell :params="{content: replayForm.otherRestrictions || '--', renderState:renderState, line:2}" /></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import reportMenu from './menu'
import ell from '@/components/Ell'
import { getNewReplayFrom } from '@/api/revive'
import { getDataDict } from '@/api/dataDict'
export default {
    name: 'BasicReport',
    components: {
        reportMenu,
        ell
    },
    filters: {
        formatterAac(val) {
            if (val === 1) {
                return '精准'
            } else if (val === 2) {
                return '合格'
            } else if (val === 3) {
                return '误判'
            }
            return ''

        },
        filterObtain(val, options) {
            if (options.length !== 0 && val) {
                return options.filter(el => el.code == val)[0].name
            }
            return '--'
        }
    },
    props: {
        active: {
            type: String,
            default: 'basic'
        }
    },
    data() {
        return {
            landId: this.$route.query['landId'],
            curMenu: 'basic',
            renderState: false,
            devEnterprise: [], // 开发企业
            singleList: [], // 单一
            unionList: [], // 联合
            housingPrices: '',
            isObtains: 0,
            replayForm: {},
            obtainOptions: []
        }
    },
    async created() {
        await this.getDataDict(101001)
        this.fetchReplayFrom()
    },
    mounted() {
    },
    methods: {
        async getDataDict(type) {
            await getDataDict({type}).then((res) => {
                this.obtainOptions = res && res
            })
        },
        switchMenu(type) {
            this.$emit('switchMenu', type)
        },
        // 查询复盘from
        fetchReplayFrom() {
            getNewReplayFrom(this.landId).then(res => {
                this.replayForm = res || {}
                this.devEnterprise = res.housingPrices ? res.housingPrices.split(',') : []
                this.isObtains = res.isObtains // 是否我司获取
                this.renderState = true
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  .basic-report {
    font-family:PingFangTC-Medium,PingFangTC;
    background:rgba(248,248,248,1);
    overflow-y: auto;
    box-sizing: border-box;
    font-size:.28rem /* 28/100 */;
    width:100%;
    height:100%;
    padding-bottom: 1.5rem /* 150/100 */;

    .my-button {
        box-sizing: border-box;
        height:4px;
        border:1px solid rgba(151,151,151,1);
        text-align: center;
        display:inline-block;
        color:rgba(151,151,151,1);
        margin-right:.2rem /* 20/100 */;
        line-height: .6rem /* 60/100 */;
        padding:0 .2rem /* 20/100 */;
      }

      .my-button.success {
        height:.44rem /* 44/100 */;
        line-height:.44rem /* 40/100 */;
        // margin-top:23px
        border:1px solid rgba(183,235,143,1);
        color:rgba(82,196,26,1);
        font-size:.24rem /* 24/100 */;
        border-radius: .04rem /* 4/100 */;
        margin-left:.2rem /* 20/100 */;
        background:rgba(246,255,237,1);
      }

      .my-button.info {
        height:.44rem /* 44/100 */;
        line-height:.44rem /* 40/100 */;
        border:1px solid rgba(145,213,255,1);
        color:rgba(39,97,255,1);
        font-size:.24rem /* 24/100 */;
        border-radius: .04rem /* 4/100 */;
        margin-left:.2rem /* 20/100 */;
        background:rgba(230,247,255,1);
      }

      .my-button.white {
        height:.44rem /* 44/100 */;
        line-height:.44rem /* 40/100 */;
        border:1px solid white;
        color:rgba(76,162,170,1);
        font-size:.24rem /* 24/100 */;
        border-radius: .04rem /* 4/100 */;
        margin-left:.2rem /* 20/100 */;
        background:white;
      }

    .header {
      background: white;
      padding-bottom:.1rem /* 10/100 */;
      .project-name {
        box-sizing: border-box;
        // height:.9rem /* 90/100 */;
        background:rgba(247,248,250,1);
        padding:0 .3rem /* 30/100 */;
        line-height: .9rem /* 90/100 */;
        margin-bottom:.1rem /* 10/100 */;
        .name {
          font-size:.32rem /* 32/100 */;
        }
      }
      .project-name:last-of-type {
        margin-bottom: 0;
      }
    }

    .content {
      .precise {
        height:.9rem /* 90/100 */;
        line-height:.9rem /* 90/100 */;
        background:rgba(76,162,170,1);
        padding:0 .3rem /* 30/100 */;
        margin-bottom:.2rem /* 20/100 */;
        .name {
          color:white;
          font-size:.32rem /* 32/100 */;
        }
      }

      .report-menu {
        margin-bottom:.2rem /* 20/100 */;
      }

      .list {
        border-top:.01rem /* 1/100 */ solid #DDDDDD;
        border-bottom:.01rem /* 1/100 */ solid #DDDDDD;
        background:white;
        display:flex;
        flex-wrap: wrap;
        padding:.4rem /* 40/100 */ .3rem /* 30/100 */;
        .unit {
          width:50%;
          margin-bottom:.5rem /* 50/100 */;
          .label {
            font-size:.28rem /* 28/100 */;
            color:rgba(153,153,153,1);
            margin-bottom:.12rem /* 12/100 */;
          }
          .value {
            font-size:.32rem /* 32/100 */;
            color:rgba(51,51,51,1);
          }
        }

        .row-unit {
          width:100%;
          margin-bottom:.5rem /* 50/100 */;
          .label {
            font-size:.28rem /* 28/100 */;
            color:rgba(153,153,153,1);
            margin-bottom:.12rem /* 12/100 */;
          }
          .value {
            font-size:.32rem /* 32/100 */;
            color:rgba(51,51,51,1);
          }
        }
      }
    }

  }
</style>
